import { useMemo } from 'react';

import { RestOfferDefinitionsApiFactory } from '@/api/generated';

import { useApiClient } from './useApiClient.util.ts';

interface Return {
  offerDefinitionsApi: ReturnType<typeof RestOfferDefinitionsApiFactory>;
}

export const useOfferDefinitionsApiClient = (): Return => {
  const { offerDefinitionsApi } = useApiClient();

  return useMemo(
    () => ({
      offerDefinitionsApi,
    }),
    [offerDefinitionsApi],
  );
};
